import * as binderOrderItemTypes from "../enums/binderOrderItemTypes";

export default function binderOrderItemFromTab(tab, index, icon) {
	return icon ? {
		children: [],
		id: index,
		label: tab.title,
		type: binderOrderItemTypes.TAB,
		icon: icon
	} : {
		children: [],
		id: index,
		label: tab.title,
		type: binderOrderItemTypes.TAB,
	};
}
